import { LoadBlockController } from "./load_block_controller";
export class AsyncBlockController extends LoadBlockController {
    get _errorMessage() {
        return this.hasErrorMessageValue ? this.errorMessageValue : "This content failed to load";
    }
    async connect() {
        await this.loadContent();
    }
}
AsyncBlockController.targets = ["replace"];
AsyncBlockController.values = {
    endpoint: String,
    errorMessage: String,
    selector: String,
    maxRetries: Number,
};
